<template>
  <div class="flex flex-col items-start">
    <div
      v-if="region"
      class="text-lg uppercase"
      v-html="region"
    ></div>

    <div
      v-if="representative.repType"
      class="font-bold"
      v-html="representative.repType"
    ></div>

    <div
      class="font-semibold"
      v-html="representative.name"
    ></div>

    <a
      class="no-underline"
      :href="`tel:${representative.phone.replace(/[^0-9]/g, '')}`"
      v-html="representative.phone"
    ></a>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'RepresentativeEntry',

  props: {
    representative: {
      required: true,
      type: Object,
    },

    representative_type: {
      type: String,
    },
  },

  computed: {
    region() {
      if(this.representative.region) {
        return this.representative.region.replace(/^all(-| )/i, '');
      }
    },
  },
}
</script>
